import { API } from "./API";
import { getApiUrl } from "../utils/platform";

const getUsers = () => {
  return API.get(`${getApiUrl()}/api/permissions/users`);
};

const createUsers = (users) => {
  return API.post(`${getApiUrl()}/api/permissions/users`, users);
};

export const userService = {
  getUsers,
  createUsers
}; 